import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import SEOHead from '@/components/SEOHead/SEOHead';
import Header from '@/components/Header/Header';
import { WordPressAPI } from '@/config';
import FooterComponent from '@/components/Footer/FooterComponent';
import dynamic from 'next/dynamic';
import SupportHome from '@/components/SupportSection/SupportHome'

const FooterNewsModal = dynamic(import('@/components/FooterNewsModal'));

const SupportIndex = ({ data }) => {
  const { acf } = data;
  const {
    lead_values,
    meta_description,
    page_title_tag,
    paid_campaign,
    phone_number_setup,
  } = acf;

  return (
    <>
      <SEOHead>
        <title>{page_title_tag}</title>
        <meta name="description" content={meta_description} />
        <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap" rel="stylesheet" />
        <script
          type="text/javascript"
          src="//app-ab33.marketo.com/js/forms2/js/forms2.min.js"
        />
      </SEOHead>
      <Header
        phone_number={phone_number_setup}
        leadValues={lead_values}
        PaidCampaign={paid_campaign}
      />
      <SupportHome data={acf} />
      {/* Email Newsletter */}
      <FooterNewsModal />
      <FooterComponent phone_number={phone_number_setup} />
    </>
  );
};

export const getStaticProps = async () => {
  let pageNumber;
  if (WordPressAPI.pages.includes('marketing')) {
    pageNumber = '20847'
  } else {
    pageNumber = '20451'
  }
  const { data } = await axios.get(`${WordPressAPI.pages}/${pageNumber}`);

  return {
    props: {
      data,
    },
    // revalidate: 1,
  };
};

SupportIndex.propTypes = {
  data: PropTypes.object,
};

export default SupportIndex;